import React from "react";
import "./chips.css";
import { Icon } from "@mui/material";
export const Chip = ({ label, item, onClick, className, options }) => {
  return (
    <div className={`chip ${className || ""}`} role="button" tabIndex="0">
      <span className="chip-label">{label}</span>
      <span className="chip-options">
        {options.map((option, index) => (
          <Icon key={index} onClick={() => option.onClick(item)}>
            {option.icon}
          </Icon>
        ))}
      </span>
    </div>
  );
};

const Chips = ({ items, labelKey, onClick, options }) => {
  return (
    <div className="chip-container">
      {items.map((item, index) => (
        <Chip
          key={index}
          item={item}
          label={labelKey(item)}
          onClick={() => onClick(item)}
          options={options}
        />
      ))}
    </div>
  );
};

export default Chips;
